module.exports = __webpack_public_path__ + "img/reset.1f9d217e.svg";